import { contactSearch, getContactbyID } from "../../apiService/RESTApi";

// Customer lookup for the LLM mode pickers. Wraps the legacy search call so components take a
// 0-based page and get a flat shape back, and so the whole of RESTApi does not have to be mocked
// to test a picker.
//
// The search route returns names and the numeric contact id (the id space the contact-mode routes
// write to), but no phone or email, so each result is looked up by id for those, as the Contacts
// page does. A failed lookup leaves that customer without them rather than dropping it.

export const CUSTOMER_SEARCH_PAGE_SIZE = 10;

export const searchCustomers = async (
  customerArn,
  { query = "", page = 0, pageSize = CUSTOMER_SEARCH_PAGE_SIZE } = {}
) => {
  // The legacy call takes a 1-based page and converts it back itself.
  const response = await contactSearch(customerArn, query, page + 1, pageSize);

  const found = Array.isArray(response?.data) ? response.data : [];
  const customers = await Promise.all(found.map(async (customer) => {
    try {
      const details = await getContactbyID(customer.contactId);
      return {
        ...customer,
        primaryPhoneNumber: details?.primaryPhoneNumber || null,
        primaryEmailAddress: details?.primaryEmailAddress || null,
      };
    } catch (err) {
      return { ...customer, primaryPhoneNumber: null, primaryEmailAddress: null };
    }
  }));

  return {
    customers,
    page: response?.page?.number ?? 0,
    totalPages: response?.page?.totalPages ?? 0,
    totalElements: response?.page?.totalElements ?? 0,
  };
};
